module.exports = __webpack_public_path__ + "static/media/dataProtection.891617c0.svg";